export enum contactAttemptMethods {
  email = 'Email',
  pushNotification = 'Push Notification',
  text = 'Text',
}
